import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Crown, Medal, Users } from "lucide-react";
import { api } from "@/lib/api";
import { Skeleton } from "@/components/portal/ui";
import { monthLabel, shiftMonth } from "@/pages/portal/Leaderboard";

const thisMonth = () => new Date().toISOString().slice(0, 7);
const MEDAL = ["text-amber-400", "text-slate-400", "text-orange-400"];

export default function AttendanceLeaderboard() {
  const [month, setMonth] = useState(thisMonth);
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/portal/ministry/attendance-leaderboard?month=${month}`).then((r) => setData(r.data)).catch(() => setData({ enabled: false, leaderboard: [] }));
  }, [month]);

  if (data && data.enabled === false) return null;
  return (
    <div className="bg-white rounded-3xl p-5 border border-slate-100 shadow-sm" data-testid="attendance-leaderboard">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-extrabold text-slate-900 flex items-center gap-2 min-w-0"><Users className="w-4 h-4 text-blue-600 shrink-0" /><span className="truncate">{data?.title || "Jemaat Paling Rajin Ibadah"}</span></p>
        <div className="flex items-center shrink-0">
          <button onClick={() => setMonth((m) => shiftMonth(m, -1))} data-testid="attendance-rank-prev" className="w-7 h-7 rounded-lg grid place-items-center text-slate-500 hover:bg-slate-100"><ChevronLeft className="w-4 h-4" /></button>
          <span className="text-[10px] font-bold text-slate-600 tabular-nums whitespace-nowrap" data-testid="attendance-rank-month">{monthLabel(month)}</span>
          <button disabled={month >= thisMonth()} onClick={() => setMonth((m) => shiftMonth(m, 1))} data-testid="attendance-rank-next" className="w-7 h-7 rounded-lg grid place-items-center text-slate-500 hover:bg-slate-100 disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
        </div>
      </div>
      {!data ? <Skeleton className="h-40 mt-4" /> : data.leaderboard.length === 0 ? (
        <p className="mt-3 text-sm text-slate-500" data-testid="attendance-rank-empty">Belum ada kehadiran tercatat bulan ini. Yuk hadir & check-in ibadah!</p>
      ) : (
        <>
          <p className="mt-1 text-xs text-slate-500">{data.members} jemaat · {data.total_checkins} check-in ibadah</p>
          <div className="mt-3 divide-y divide-slate-50">
            {data.leaderboard.map((m) => (
              <div key={m.user_id} className="py-2.5 flex items-center gap-3" data-testid={`attendance-rank-row-${m.rank}`}>
                <span className={`w-7 shrink-0 text-center font-black tabular-nums ${m.rank <= 3 ? MEDAL[m.rank - 1] : "text-slate-300"}`}>
                  {m.rank === 1 ? <Crown className="w-5 h-5 mx-auto" /> : m.rank <= 3 ? <Medal className="w-5 h-5 mx-auto" /> : m.rank}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-bold text-slate-900 truncate">{m.name}</span>
                  <span className="block text-[11px] text-slate-400 truncate">{m.favorite_service || "Ibadah"}</span>
                </span>
                <span className="shrink-0 text-right">
                  <span className="block text-sm font-black text-blue-600 tabular-nums">{m.count}x</span>
                  <span className="block text-[10px] text-slate-400">{m.weeks} hari</span>
                </span>
              </div>
            ))}
          </div>
          {data.me && (
            <div className="mt-3 rounded-2xl bg-slate-900 text-white px-4 py-3 flex items-center justify-between" data-testid="attendance-rank-me">
              <span className="text-sm font-bold">Peringkat Anda #{data.me.rank}</span>
              <span className="text-sm font-black tabular-nums">{data.me.count}x hadir</span>
            </div>
          )}
        </>
      )}
    </div>
  );
}
